import { useRolodexEntries } from 'features/rolodex'
import { GeckoComponentModelType, RolodexEntryType } from 'types'

const TEMPLATE_ASSET_ORG = 'template-asset-org'

export const useComponentTemplates = (
  selectedComponentType: GeckoComponentModelType | undefined
) => {
  const { isLoading, assetModels: componentTemplateAssetModels } =
    useRolodexEntries({
      type: RolodexEntryType.ASSET_MODEL,
      tags: {
        organization: TEMPLATE_ASSET_ORG,
      },
    })

  const applicableTemplates = componentTemplateAssetModels.flatMap(
    (assetModel) => {
      const components = Array.from(assetModel.data.components.values())
      return components.filter(
        (component) => component.type === selectedComponentType
      )
    }
  )

  return { isLoading, applicableTemplates }
}
